import { useEffect, useRef } from 'react';
import { Menu } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';

/** @component
 * Creates the UserMenu.
 * @param anchor
 * @param open
 * @param onClose
 * @param children
 * @returns {React.Element}
 * @constructor
 */
export const UserMenu = ({ anchor, open, onClose, children }) => {
    const descriptionElementRef = useRef(null);

    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    return (
        <Menu
            id='basic-menu'
            anchorEl={anchor}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 15, //horizontal offset for popper arrow
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0
                        }
                    }
                }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            data-analyticsid='account-menu'
        >
            {children}
        </Menu>
    );
};

UserMenu.propTypes = {
    anchor: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.array.isRequired
};
